import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface FloatingActionButtonProps {
  onClick: () => void;
  icon: ReactNode;
  labelKey: string;
  isLoading?: boolean;
  disabled?: boolean;
}

/**
 * Shared action button used inside the floating selection bar for non-destructive actions.
 * It keeps one consistent style and loading state across all list pages.
 */
export function FloatingActionButton({
  onClick,
  icon,
  labelKey,
  isLoading = false,
  disabled = false,
}: FloatingActionButtonProps) {
  const { t } = useTranslation();
  const isDisabled = isLoading || disabled;

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={onClick}
      className="text-onsurface hover:bg-surface-darker inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm font-medium transition-colors disabled:opacity-50"
    >
      {isLoading ? (
        <div className="border-primary size-4 animate-spin rounded-full border-2 border-t-transparent" />
      ) : (
        icon
      )}
      {t(labelKey)}
    </button>
  );
}
